<template>
  <v-dialog v-model="popupStore.$state.showDialog" persistent width="80%" min-width="200" max-width="500">
    <div class="popup-box">
      <span class="popup-title mb-3" v-if="!strUtil.isEmpty(popupStore.$state.dialogInfo.title)">
        {{ popupStore.$state.dialogInfo.title }}
      </span>
      <span class="popup-contents mb-7">
        {{ popupStore.$state.dialogInfo.msg }}
      </span>
      <div class="popup-btn">
        <c-btn :thema="'fw-gby'" :btnText="t('confirm')" :readOnly="false" :btnSize="14"
          :customDesign="{ width: '100%', textAlign: 'center' }" @onClicked="closeDialog"></c-btn>
      </div>
    </div>
  </v-dialog>
</template>

<script setup>
import CBtn from '@/components/cBtn.vue'
import { strUtil } from '@/utils/'
import { usePopupStore } from '@/stores/popup'
import { useI18n } from 'vue-i18n';
const popupStore = usePopupStore()
const { t, locale } = useI18n();
const closeDialog = () => {
  popupStore.closeDialog();
}
</script>
<style lang="scss" scoped>
@import '@/sass/app.scss';

.popup-box {
  box-shadow: 0px 4px 40px rgba(0, 0, 0, 0.08);
  border-radius: 24px;
  background-color: #fff;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 32px 24px 24px;
  box-sizing: border-box;
}

.popup-title {
  display: inline-block;
  width: 100%;
  font-size: 20px;
  letter-spacing: -0.8px;
  line-height: 32px;
  font-weight: 600;
  color: #111;
}

.popup-contents {
  display: inline-block;
  width: 100%;
  font-size: 15px;
  letter-spacing: -0.4px;
  line-height: 24px;
  color: #666;
}

.popup-btn {
  width: 100%;
  display: flex;
  justify-content: end;
}
</style>
